// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
    suggestionMobileStyle: "style2",
  },
};

(function () {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function () {
    var suggestionElement = this.$uiMenuElement;
    var searchElement = this.$element;
    var searchBoxId = this.id;
    jQ(".search_box .form-row .col").append(
      `<button class="boost-pfs-button"><span><svg aria-labelledby="svg-submit_arrow" role="img" width="59px" height="15px" viewBox="0 0 59 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title id="svg-submit_arrow">Submit</title>
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g id="Black-Footer" transform="translate(-1208.000000, -174.000000)" stroke="#111111" stroke-width="1.5">
            <g id="Email" transform="translate(841.000000, 102.000000)">
                <g id="Email" transform="translate(0.000000, 49.000000)">
                    <path d="M389.532214,10.2708486 L395.544454,2.69617159 L402.266381,10.2708486 M395.623186,58.7760512 L395.626,3.43478495" id="Combined-Shape" transform="translate(395.899297, 30.736111) rotate(90.000000) translate(-395.899297, -30.736111) "></path>
                </g>
            </g>
        </g>
    </g>
</svg></span></button>`
    );
  };

  jQ(document).ready(function () {
    jQ(".search_box .form-row .col").append(
      `<button class="boost-pfs-button"><span><svg aria-labelledby="svg-submit_arrow" role="img" width="59px" height="15px" viewBox="0 0 59 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title id="svg-submit_arrow">Submit</title>
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g id="Black-Footer" transform="translate(-1208.000000, -174.000000)" stroke="#111111" stroke-width="1.5">
            <g id="Email" transform="translate(841.000000, 102.000000)">
                <g id="Email" transform="translate(0.000000, 49.000000)">
                    <path d="M389.532214,10.2708486 L395.544454,2.69617159 L402.266381,10.2708486 M395.623186,58.7760512 L395.626,3.43478495" id="Combined-Shape" transform="translate(395.899297, 30.736111) rotate(90.000000) translate(-395.899297, -30.736111) "></path>
                </g>
            </g>
        </g>
    </g>
</svg></span></button>`
    );
  });

  BoostPFS.prototype.init = function () {
    //    FunctionMapper.mapLegacyFunctions();
    Settings.init();
    Labels.init();
    Selector.init();
    Globals.init();
    //    Navigation.init();
    //    this.initOTP();
    //    this.initADA();
    var language = jQ("html").attr("lang");
    Labels.search.resultNumber = '{{ count }} results for "{{ terms }}"';
  };
})();
